// Game companion answer check: digits only; the right code (data-code) opens the finale page (data-url),
// a wrong one shows [data-answer-error] and marks the input invalid.
class SAnswerCheck extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.querySelector('form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.#check();
    }, { signal });
    this.#input?.addEventListener('input', () => {
      const digits = this.#input.value.replace(/\D/g, '').slice(0, Number(this.dataset.length) || 4);
      if (digits !== this.#input.value) this.#input.value = digits;
      this.#showError(false);
    }, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  get #input() {
    return this.querySelector('[data-answer-input]');
  }

  #check() {
    if (this.#input?.value.trim() === this.dataset.code) {
      window.location.href = this.dataset.url;
    } else {
      this.#showError(true);
    }
  }

  #showError(show) {
    const error = this.querySelector('[data-answer-error]');
    if (error && error.hidden === show) error.hidden = !show;
    this.#input?.setAttribute('aria-invalid', show ? 'true' : 'false');
  }
}

if (!customElements.get('s-answer-check')) customElements.define('s-answer-check', SAnswerCheck);
